// Enum of string ids for new Feature Flags
export enum StringFeatureFlags {
  RERANKING_SEARCH = 'relevanceRerankingSearch',
  DS_RESULTS_ONLY_SORTED_LISTING = 'dsResultsOnlySortedListingFF',
}

// Enum of string ids for new AB Tests Flags
export enum StringABTests {
  AUTOSELECT_BEST_CATEGORY = 'autoselectBestCategory',
  DS_RESULTS_ONLY = 'dsResultsOnlyWithSortedListing',
  SEARCH_AI = 'searchAI',
  HVC_RERANKING = 'hvcReranking',
}

// TTL 1 hour
export const SEARCH_S_MAX_AGE = 3600;
